module.exports = __webpack_public_path__ + "static/homlan-banner-4593d3e90645c9273401846fd34c6bc5.png";